import { roundOffAndFormatNumberWithCurrency } from '../../../utils/utils'

interface StatCardProps {
  value: string | number
  label: string
  formatAsCurrency?: boolean
}

function StatCard({ value, label, formatAsCurrency = false }: StatCardProps) {
  const displayValue =
    formatAsCurrency && typeof value === 'number'
      ? roundOffAndFormatNumberWithCurrency(value)
      : typeof value === 'number'
        ? String(value)
        : value
  return (
    <div
      className="flex-1 px-4 py-3 border-[1.5px] border-[#F0F4F7] rounded-[12px] flex flex-col justify-center min-h-[80px]"
    >
      <span
        className="text-[24px] font-[500] leading-[110%] text-[#CC5C2D]"
      >
        {displayValue}
      </span>
      <span
        className="text-[13px] font-[400] text-[#6A6E6E] leading-[120%] mt-1"
      >
        {label}
      </span>
    </div>
  )
}

interface StatCardsProps {
  amount: number
  amountLabel: string
  count: number
  countLabel: string
  className?: string
}

export function StatCards({
  amount,
  amountLabel,
  count,
  countLabel,
  className = '',
}: StatCardsProps) {
  return (
    <div className={`flex flex-col gap-3 pt-[22px] pb-6 ${className}`}>
      <StatCard value={amount} label={amountLabel} formatAsCurrency />
      <StatCard value={String(count)?.padStart(2, '0')} label={countLabel} />
    </div>
  )
}
